import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { QuestionnaireService } from '../services/questionnaire.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LiabilitiesArrayComponent } from '../liabilities-array/liabilities-array.component';
import { ValidateDate } from '../date-validator';
import { Draft } from '../services/draft.service';
import { ValidateNegativeNumber } from '../negative-number-validator';
import { SystemTablesService } from '../services/system-tables.service';
import { SysTableObj } from '../models/sysTableObj.model';
import { TranslateService } from '@ngx-translate/core';
import { DatePickerComponent } from '../date-picker/date-picker.component';

@Component({
	selector: 'app-liabilities',
	templateUrl: './liabilities.component.html',
	styleUrls: ['./liabilities.component.scss']
})
export class LiabilitiesComponent implements OnInit, AfterViewChecked, AfterViewInit {
	private route$: Subscription;
	qID: any;
	prevQID: any;
	liabilities = [];
	liabilitiesNumber: number = 1;
	liabilitiesIndex: number = 0;
	//question 1
	visibleQids;
	editQuestion;
	currentStep;
	submitQID;
	liabilitiesForm: FormGroup;
	submitted;
	isEdit;
	window = window;
	liabilitiesObjects: SysTableObj[];
	liabilitiesTypes: string[];

	qFields = {
		1: [{ name: "realtyLien", validators: [Validators.required] }],
		2: [{ name: "monthlyRefundAmount", validators: [Validators.required] }],
		3: [{ name: "whenLiabilitiesEnd", validators: [Validators.required, ValidateNegativeNumber] }],
		3.1: [{ name: "amountOfAlimonyPayment", validators: [Validators.required] }],
		3.2: [{ name: "endDate", validators: [Validators.required, ValidateDate], type: "Date" }],
		4: [{ name: "haveYouLiabilities", validators: [Validators.required] }],
		5: [{ name: "liabilitiesArray", type: "LiabilitiesArray" ,systemTable:"arrayTable",
		qNamesSystemTable: [[["liabilityType"],["liabilityType"]]],
		numberSystemTable: [[["2122"],["2122"]]]}],
	};

	qArrFields = {
		5: [
			{ name: "liabilityType", validators: [Validators.required] },
			{ name: "liabilityBalance", validators: [Validators.required] },
			{ name: "liabilityMonthlyRefund", validators: [Validators.required] },
			{ name: "liabilityEndDate", validators: [Validators.required] }
		]
	};

	@ViewChild('endAlimonyPaymentDate') endAlimonyPaymentDate: DatePickerComponent;

	constructor(
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		private fb: FormBuilder,
		private draft: Draft,
		private sysTableService:SystemTablesService,
		private _changeDetector: ChangeDetectorRef,
		private translate: TranslateService
	) { }

	ngOnInit() {
		this.liabilitiesObjects =  this.sysTableService.getTable('2122',false);
		this.liabilitiesTypes = this.liabilitiesObjects.map(v=>v.name);

		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;

			if (!this.draft.isBuildForm) {
				let step4 = this.questionnaireService.getStep("borrowers-details");
				let step4Quest2 = this.questionnaireService.getQuestion(step4, "4.1");
				let quest5 = this.questionnaireService.getQuestion(this.currentStep, "5");
				let quest4 = this.questionnaireService.getQuestion(this.currentStep, "4");
				let respMezonot = step4Quest2.selectedAnswer[0] === "YES";

					if (respMezonot) {
						quest5.answer.fieldsArray[0].required = true;
						if (quest4 && quest4.selectedAnswer) {
							quest4.selectedAnswer[0] = "YES";
						}
					}
					else {
						quest5.answer.fieldsArray[0].required = false;
						if (quest4 && quest4.selectedAnswer) {
							quest4.selectedAnswer[0] = "NO";
						}
					}
					this.rebuildFormFor5();
			}

			if (params.qid === "all") {
				this.isEdit = true;
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			} else {
				this.isEdit = false;
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);

				if (this.qID !== '1') {
					this.setFocusFirstComponent(this.qID);
				}
			}
		});
		if (this.draft.autoForm) {
			this.liabilitiesForm = this.draft.buildForm(this.currentStep, this.liabilitiesForm);
		}
		this.draft.updateOpportunity$("4").subscribe(r =>
			console.log(r)
			, error => { console.log(error) });
	}

	ngAfterViewInit(): void {
		this.setFocusFirstComponent('1');
	}

	private setFocusFirstComponent(qID) {
		if (qID === '1') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('BLIABILITIES.QUESTION1.REQUIRED1')}"]`);
		} else if (qID === '2') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('LIABILITIES.QUESTION2.QUESTION')}"]`);
		} else if (qID === '3') {
			this.focusToElement(`input[aria-label="${this.translate.instant('LIABILITIES.QUESTION3.QUESTION')}"]`);
		} else if (qID === '3.1') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('LIABILITIES.QUESTION3-1.QUESTION')}"]`);
		} else if (qID === '3.2') {
			this.focusToElement(`input[aria-label="${this.translate.instant('LIABILITIES.Q3-2.QUESTION')}"]`);
			this.endAlimonyPaymentDate.toggleD2();
		} else if (qID === '4') {
			this.focusToElement(`label[data-id="qID4a"`);
		} else if (qID === '5') {
		}
	}

	rebuildFormFor5() {
		this.liabilitiesForm.setControl('liabilitiesArray', LiabilitiesArrayComponent.buildLiabilities(this.questionnaireService.getQuestion(this.currentStep, "5").answer['fieldsArray']));
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("liabilities");

		this.liabilitiesForm = this.fb.group({
			realtyLien: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			monthlyRefundAmount: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			whenLiabilitiesEnd: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue,
			amountOfAlimonyPayment: this.questionnaireService.getQuestion(this.currentStep, "3.1").answer.fields[0].answerValue,
			endDate: this.questionnaireService.customFormat(this.questionnaireService.getQuestion(this.currentStep, "3.2").answer.fields[0].answerValue),
			haveYouLiabilities: this.questionnaireService.getQuestion(this.currentStep, "4").selectedAnswer,//problem with button
			liabilitiesArray: LiabilitiesArrayComponent.buildLiabilities(this.questionnaireService.getQuestion(this.currentStep, "5").answer.fieldsArray)
		});
	}

	setValidators() {
		this.questionnaireService.clearAllQuestionValidators(this.liabilitiesForm.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.liabilitiesForm.controls, this.qFields, "5", this.qArrFields);

		this.submitted = false;
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
			this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			this.questionnaireService.isActiveEditQuestion = false;
		}
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent): any {
		if (event.key === 'Enter') {
			if ((event.target as HTMLElement).dataset.fieldname === 'haveYouLiabilities') {
				this.liabilitiesForm.controls[(event.target as HTMLElement).dataset.fieldname].setValue((event.target as HTMLElement).dataset.fieldvalue);
				this.onSubmit(this.liabilitiesForm);
			}

		}

	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit(): valid=", valid, "value", value);
		this.submitted = true;
		if (!valid) {
			this.questionnaireService.submitForm(true);
		}
		else {
			this.questionnaireService.submitForm(false);
		}
		if (valid) {
			let q;
			this.submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[this.submitQID];

			value = this.liabilitiesForm.getRawValue();

			let values = q.map(r => {
				return value[r.name];
			});

			let valueTmp = JSON.parse(JSON.stringify(value));
			this.setLiablitiesCode(valueTmp);

			this.draft.buildArrDraft(this.submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit)
			this.questionnaireService.sendGA(this.currentStep, this.qID, values);
			this.nextClick(this.submitQID, values);
		}

		window["logInvalidControls"](this.liabilitiesForm);
	}

	private setLiablitiesCode(value) {
		if (this.submitQID === "5") {
			for (let i = 0; i < value["liabilitiesArray"].length; i++) {
				let liabilityCode = this.liabilitiesObjects.find(v => v.name === value["liabilitiesArray"][i].liabilityType).code;
				value["liabilitiesArray"][i].liabilityType = liabilityCode;
			}
		}
	}

	editQuestionChange(qid) {
		if(this.questionnaireService.isActiveEditQuestion === false){
			this.questionnaireService.isActiveEditQuestion = true;
			this.qID = qid;
			this.setValidators();
		}
	}

	ngAfterViewChecked(): void {
		if (!this._changeDetector['destroyed']) {
			this._changeDetector.detectChanges();
		}
	}

	focusToElement(selector: string) {
		const selectedElement = Array.from(document.querySelectorAll(selector));

		if (selectedElement && selectedElement.length > 0) {
			const nowActiveElement = document.activeElement;
			(nowActiveElement as HTMLElement).blur();
			setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/liabilities/liabilities.component.ts